import { useQuery } from "@tanstack/react-query";
import { useIsApiReady } from "../hooks/use-api-ready";
import {
  groupExpertControllerGetAll,
  type GetExpertsFilterDto,
} from "../lib/gen-api";
import { queryKeys } from "../lib/query-keys";

export const useGroupExpertsData = (
  groupUuid?: string | null,
  filter?: GetExpertsFilterDto,
) => {
  const {
    data: experts,
    isPending,
    error,
  } = useQuery({
    enabled: useIsApiReady() && !!groupUuid,
    queryKey: queryKeys.groupExperts(groupUuid!, filter),
    queryFn: () => {
      return groupExpertControllerGetAll({
        path: {
          groupUuid: groupUuid!,
        },
        query: {
          filter,
        },
      }).then((res) => res.data?.data ?? []);
    },
  });

  return { experts: experts ?? [], isLoading: isPending, error };
};
